// extracted by mini-css-extract-plugin
module.exports = {"searchPadding":"bpmRps_searchPadding__rbLFK","bpmRpsLoading":"bpmRps_bpmRpsLoading__182ly","bpmRpsStatTbl":"bpmRps_bpmRpsStatTbl__3_oFN"};